import { create } from "zustand";

import { AvailableRoles, GoogleCalendarConnectionStatus } from "@/types";

export interface UserData {
  id: string;
  firstName: string | null;
  lastName: string | null;
  avatarUrl: string | null;
  fullName: string | null;
  role: AvailableRoles;
  isOnboarded: boolean;
  permissions: string[];
  specialRoleChecks: {
    has_subscription: boolean;
    has_public_profile: boolean;
    has_payments_setup: boolean;
    has_default_pricing: boolean;
    payment_plan: string;
    payment_plan_status: string;
    google_calendar: GoogleCalendarConnectionStatus;
  };
  timezone: string;
}

interface UserState {
  user: UserData | null;
  setUser: (userData: UserData | null) => void;
  shouldReload: boolean;
  setShouldReload: (shouldReload: boolean) => void;
  redirectPath: string | null;
  setRedirectPath: (redirectPath: string | null) => void;
}

const useUserStore = create<UserState>()((set) => ({
  user: null,
  setUser: (userData) => {
    set(() => ({ user: userData }));
  },
  shouldReload: false,
  setShouldReload: (shouldReload) => {
    set(() => ({ shouldReload }));
  },
  redirectPath: null,
  setRedirectPath: (redirectPath) => {
    set(() => ({ redirectPath }));
  },
}));

export default useUserStore;

export const selectUserTimezone = (state: UserState) => state.user?.timezone;
